import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Mega Pack después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos ya tenés todo descargado. 100% PDF.'
  }, {
    q: '¿Necesito experiencia previa en herrería o carpintería?',
    a: 'No. Todo está diseñado para principiantes. Las guías son paso a paso, con fotos, medidas y explicaciones claras.'
  }, {
    q: '¿Los planos incluyen lista de materiales y medidas?',
    a: 'Sí. Cada plano incluye medidas exactas, lista de materiales, herramientas necesarias y pasos de armado.'
  }, {
    q: '¿Puedo usar los planos para fabricar y vender?',
    a: 'Absolutamente. Los planos son tuyos para uso personal y comercial. Muchos compradores ya fabrican y venden con ellos.'
  }, {
    q: '¿Sirve para mi país o solo para Argentina?',
    a: 'Sirve para cualquier país. Los materiales y técnicas son universales. Pagarás en la moneda de tu país.'
  }, {
    q: '¿Qué herramientas necesito para empezar?',
    a: 'Herramientas básicas de taller. Cada proyecto indica las herramientas necesarias. Podés empezar con lo mínimo e ir creciendo.'
  }, {
    q: '¿Los 5 regalos están incluidos en todas las ofertas?',
    a: 'Sí, el Mega Pack incluye los 5 regalos: Trailers, Herrero, Gym, Soldador y +1500 Planos.'
  }, {
    q: '¿Es material descargable o necesito internet?',
    a: 'Todo es descargable en PDF. Una vez que lo bajás, no necesitás internet para consultarlo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para revisar todo el material. Si no cumple tus expectativas, te devolvemos el 100% del dinero. Sin preguntas.'
  }, {
    q: '¿Qué diferencia tiene este pack con tutoriales de YouTube?',
    a: 'Este es un sistema completo y organizado: planos profesionales con medidas, guías paso a paso, proyectos rentables listos para fabricar. No son videos sueltos ni contenido genérico.'
  }];
  return <section className="bg-[#0a0e27] py-5 md:py-16 px-4 font-sans" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center mb-5 md:mb-10 flex items-center justify-center gap-4" data-id="element-42">
          <span className="text-4xl md:text-5xl" data-id="element-43">❓</span>
          <span data-id="element-44">
            <span className="text-white" data-id="element-45">PREGUNTAS </span>
            <span className="text-[#f97316]" data-id="element-46">FRECUENTES</span>
          </span>
        </h2>

        <div className="space-y-2 md:space-y-3" data-id="element-47">
          {faqs.map((faq, i) => <div key={i} className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 md:p-6 text-left group hover:bg-[#161c45] transition-colors" data-id="element-49">
                <div className="flex items-center gap-4 flex-1" data-id="element-50">
                  <span className="text-[#f97316] font-bold text-base md:text-lg whitespace-nowrap" data-id="element-51">
                    {i + 1} —
                  </span>
                  <span className="font-bold text-white text-base md:text-lg" data-id="element-52">
                    {faq.q}
                  </span>
                </div>
                <span className="text-gray-500 ml-4 flex-shrink-0 text-sm" data-id="element-53">
                  {openIndex === i ? '▲' : '▼'}
                </span>
              </button>
              {openIndex === i && <div className="px-4 md:px-6 pb-4 md:pb-6 pt-0 ml-12 md:ml-14" data-id="element-54">
                  <p className="text-gray-400 text-base md:text-lg leading-relaxed border-t border-gray-800 pt-4" data-id="element-55">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}